import { useContext, useEffect, useRef, useState } from 'react';

import styled from '@emotion/styled';
import theme from '../theme';

import Slider from "react-slick";
import "../css/slick.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { FadeInSection } from '../hooks/FadeInSection';


export default function SliderComponent() {    

    const { selectLanguage } = useContext(LangContext);
    const { isMobile } = useContext(DeviceContext);
    const [currentSlide, setCurrentSlide] = useState(0);

    const slider = useRef(null);

    var settings = {
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        //dotsClass: "button__bar",     
        beforeChange: (oldIndex, newIndex) => {
            console.log(newIndex + 'ㅌ세ㅡㅡ트');
            setCurrentSlide(newIndex);
        },
        customPaging: function(i) {

            
        return (
            <div 
                className={`custom-dot ${currentSlide === i ? 'active' : ''}`}
                style={currentSlide === i ? {background:'rgba(255, 255, 255, 1)'} : {background:'rgba(255, 255, 255, 0.5)'} }
            >{i}</div>
        );
        },
    };

    const settingsWithModules = {
        ...settings,
        dotsClass: 'button__bar'
    };

    const SlideSection = styled.section`
        position:relative;
    `;

    const Title1 = styled.div`
        font-size:1.875rem;
        color:white;
        opacity:.2;
        // margin-bottom: 30px;

        display:flex;
        align-items:center;
        justify-content:center;
        gap:6px;

        ${theme.breakpoints.xl_1920} {
            font-size:20px;
        }

        ${theme.breakpoints.xl} {
            font-size:14px;
            margin-top:80px;
        }
    `;

    const TitleNumber = styled.span`
        font-size:4.375rem;
        //margin-bottom:10px;

        ${theme.breakpoints.xl_1920} {
            font-size:50px;
        }

        ${theme.breakpoints.xl} {
            font-size:24px;                   
            line-height:165%;     
        }
    `;

    const Title2 = styled.div`
        font-size:4.125rem;
        color:white;
        margin-bottom:14px;

        ${theme.breakpoints.xl_1920} {
            font-size:52px;
        }

        ${theme.breakpoints.xl} {
            font-size:28px;
            margin-bottom:14px;
        }
    `;
    
    const Text = styled.div`
        font-size: 1.75rem;
        font-family: "Gmarket Sans";
        line-height: 165%; 
        color:white;
        opacity: .8;
        white-space: pre-line;
        margin-bottom:14px;

        ${theme.breakpoints.xl_1920} {
            font-size:24px;
        }

        ${theme.breakpoints.xl} {            
            height:95px;
            font-size:14px;
            margin-bottom:14px;
            font-weight: 500;
        }
    `;

    const koreanSlide = {
        0 : ['토이 드래곤 수집' , '총 300마리가 넘는 캐릭터! '+(isMobile ? '\r\n' : '')+'다양한 토이 드래곤을 수집하고 키워보세요.\r\n합성과 강화를 통해 더욱 강력한 등급의 '+(isMobile ? '\r\n' : '')+'토이 드래곤을 만들 수도 있습니다.'],
        1 : ['배틀 아레나' , '토이 드래곤 5마리로 전략적인 덱을 구성하여 '+(isMobile ? '\r\n' : '')+'끝까지 살아남는 쪽이 승리!\r\n아레나에서 승리하여 "랭크"를 올리면 '+(isMobile ? '\r\n' : '')+'특별한 보상을 획득할 수 있습니다.'],
        2 : ['보스 레이드' 
            , `방어팀과 공격팀을 배치하여 강력한 보스를 물리치세요! `+(isMobile ? '\r\n' : '')+` 드래곤들의 전략적 배치가 핵심!
                일일,주간,누적 랭킹에 따른 `+(isMobile ? '\r\n' : '')+`강력한 보상이 준비되어 있으니 포기하지 마세요!`],
        3 : ['스테이지 탐험' 
            , `8개 월드로 구성된 탐험 스테이지에 `+(isMobile ? '\r\n' : '')+`끊임없이 도전하세요!
                스테이지별 차별화된 보상이 여러분을 기다립니다.`+(isMobile ? '\r\n' : '')+` 지금 바로 탐험을 시작하세요!`],
        4 : ['태엽 공장' 
            , `최정예 드래곤을 세팅하여 `+(isMobile ? '\r\n' : '')+`태엽 공장을 정복하세요!
                매일 다른 직업의 드래곤 스킬 강화 재료를 `+(isMobile ? '\r\n' : '')+`획득할 수 있으니 절대 놓치지 마세요!`],
        5 : ['블록 타운 ' , `귀여운 토이 드래곤들이 뛰어노는 `+(isMobile ? '\r\n' : '')+`블록 타운을 차근차근 건설해보세요!
                            토이 드래곤 강화에 필수적인 생산품을 `+(isMobile ? '\r\n' : '')+` 끊임없이 만들어낼 수 있습니다.`]
    }

    const engSlide = {
        0 : ['TOY DRAGON' , 'Collect and nurture 300+ Toy Dragons, '+(isMobile ? '\r\n' : '')+'each with unique traits.'+(isMobile ? '\r\n' : '\r\n')+'Use synthesis and enhancement'+(isMobile ? '\r\n' : '')+'to craft powerful-grade dragons.'],
        1 : ['BATTLE ARENA' , 'Survive to victory with '+(isMobile ? '\r\n' : '')+'a strategic deck of five Toy Dragons!'+(isMobile ? '\r\n' : '')+''+(isMobile ? '' : '\r\n')+'Climb ranks in the Arena'+(isMobile ? '\r\n' : '')+'for special rewards.'],
        2 : ['BOSS RAID' 
            , `Strategic dragon placement is crucial `+(isMobile ? '\r\n' : '')+`to defeat powerful bosses!
            Powerful rewards await based on daily, `+(isMobile ? '\r\n' : '')+`weekly, and cumulative rankings.`],
        3 : ['EXPLORATION' 
            , `Constantly challenge `+(isMobile ? '\r\n' : '')+`the adventure stages consisting of 8 worlds!
                Unique rewards await `+(isMobile ? '\r\n' : '')+`you for each stage!`],
        4 : ['FACTORY DUNGEON' 
            , `Conquer the Leaf Factory`+(isMobile ? '\r\n' : '')+`with your elite Toy Dragons!
                Daily, acquire skill enhancement materials `+(isMobile ? '\r\n' : '')+`from various professions.`],
        5 : ['BLOCK TOWN' , `Build a bustling Block Town `+(isMobile ? '\r\n' : '')+`where cute Toy Dragons frolic!
                            Plus, craft essential `+(isMobile ? '\r\n' : '')+`goods along the way.`]
    }
    
    const styleDiv = {
        display: isMobile ? 'block' : 'none',
        position:'relative',
        bottom:'0px',
        width:'100%',
        height:'auto',
        //overflow:'hidden',
        //zIndex:'9'
    }

  return (
    <>                
        <Title1>            
            {selectLanguage === '한국어' ?
                <>
                    <TitleNumber>02</TitleNumber>게임 소개
                </>
                :
                <>
                    <TitleNumber>02</TitleNumber>FEATURE
                </>                
            }
        </Title1>
        <FadeInSection>
        <Title2>{selectLanguage === '한국어' ? koreanSlide[currentSlide][0] : engSlide[currentSlide][0] }</Title2>        
        <Text>            
            {selectLanguage === '한국어' ? koreanSlide[currentSlide][1] : engSlide[currentSlide][1] }
        </Text>
        </FadeInSection>        
        
        <FadeInSection>
            <div className="sliderContainer">            
                <div className="sliderArrows">
                    <button onClick={() => slider?.current?.slickPrev()}>
                    <img src="/images/icon/leftArrow_big.png" alt=""/>
                    </button>
                    <button onClick={() => slider?.current?.slickNext()}>
                    <img src="/images/icon/rightArrow_big.png" alt=""/>
                    </button>
                </div>
                <Slider ref={slider} {...settingsWithModules}>
                    <div className="sliderImages">
                        <img src="/images/slide1.png" alt="slider"/>
                    </div>
                    <div className="sliderImages">
                        <img src="/images/slide2.png" alt="slider"/>
                    </div>
                    <div className="sliderImages">
                        <img src="/images/slide3.png" alt="slider"/>
                    </div>
                    <div className="sliderImages">
                        <img src="/images/slide4.png" alt="slider"/>
                    </div>                
                    <div className="sliderImages">
                        <img src="/images/slide5.png" alt="slider"/>
                    </div>
                    <div className="sliderImages">
                        <img src="/images/slide6.png" alt="slider"/>
                    </div>
                </Slider>                
            </div>
        </FadeInSection>
        <div style={styleDiv}>
            <img src="/images/bg_char_left_big.png" alt="" className={selectLanguage === '한국어' ? 'kor_logo1' : 'eng_logo1'} style={{width:'165px', height:'213px'}}/>
            <img src="/images/bg_char_right_big.png" alt="" className={selectLanguage === '한국어' ? 'kor_logo2' : 'eng_logo2'} style={{width:'171px', height:'215px'}}/>            
        </div>
    </>
  )
}